import React from 'react';
import { Modal, Row, Col, Input, Alert, Empty } from 'antd';
import { SearchOutlined, LoadingOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import AllGigsFilter from '../../pages/SearchSkillListing/components/AllGigs/AllGigsFilter';
import ChooseGigsButton from '../PlaceBidModal/ChooseGigsButton';
import JobCard from '../JobCard/JobCard';
import { useLocation } from 'react-router-dom';

const ChooseGigModal = ({
  modalType,
  setmodalType,
  windowDimensions,
  searchText,
  searchHandler,
  searchPublish,
  fetchMoreData,
  hasMore,
  loadingGigs,
  gigAlert,
  setGigAlert,
  setselectedGigDetails,
  selectedGigDetails,
  props,
  flag,
  history,
  getUserName,
  nextHandler,
  backHandler,
  getImageByStateCode,
  handleApplyFilter,
  setGigType,
  GigType,
  setSearchFilters,
  searchFilters
}) => {
const location = useLocation();
  return (
    <Modal
      visible={
        (modalType === 'Choose a gig') ||
        (modalType !== 'Edit Bid' && props?.fromDetailPage && props?.HidePagePvt) ||
        location.pathname === '/editBidPage'
      }
      onCancel={() => setmodalType('Edit Bid')}
      footer={null}
      width={1000}
      className="editBidModal"
    >
      <div className="ChooseGig-cantainer-pvt-tal">
        <div className="ChooseGig-Title-pvt">Choose a gig</div>
        <div className="ChooseGig-Section-pvt">
          <Row>
            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
              <Input
                className="chooseJobSearch-placeBid"
                style={{
                  width: windowDimensions.width > 845 && '330px',
                  marginLeft: windowDimensions.width > 845 && '20px',
                }}
                placeholder="Gig title..."
                value={searchText}
                prefix={<SearchOutlined className="joblisting-searchicon" />}
                onChange={(e) => searchHandler(e.target.value)}
                allowClear
              />
            </Col>
          </Row>
          <AllGigsFilter
            setGigType={setGigType}
            GigType={GigType}
            searchText={searchText}
            handleApplyFilter={handleApplyFilter}
            windowDimensions={windowDimensions}
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
            defaultParams={{ JobOrderStatusName: 'Published' }}
            isDropdownClose={true}
          />
          {gigAlert && (
            <Alert
              style={{
                display: gigAlert ? '' : 'none',
                width: '97%',
                marginBottom: '5px',
              }}
              message="Stop Bid Alert"
              description="You have reached the max bid limit (200 bids per day) for this job for today. Try again tomorrow"
              type="warning"
              showIcon
              closable
            />
          )}
          <InfiniteScroll
            dataLength={searchPublish?.length ?? 0}
            next={fetchMoreData}
            hasMore={hasMore}
            scrollableTarget={'infinite-scroll'}
            className={'infinite-scroller-place-bid'}
          >
            <Row>
              {loadingGigs ? (
                <div className="loader-container">
                  <LoadingOutlined className="loader" />
                </div>
              ) : searchPublish?.length !== 0 ? (
                searchPublish?.map((item, index) => {
                  if (
                    item.JobOrderStatuses?.JobOrderStatusName !== 'Deleted' &&
                    item.JobOrderStatuses?.JobOrderStatusName !== 'Expired' &&
                    item.JobOrderStatuses?.JobOrderStatusName !== 'Closed'
                  ) {
                    return (
                      <Col
                        key={index}
                        xs={24}
                        sm={12}
                        md={8}
                        lg={8}
                        xl={8}
                        onClick={() => {
                          if (item.isDisabled) return;
                          if (
                            item?.status?.[3]?.count +
                              (!props.multiBid &&
                              !props.EditBid &&
                              props?.selectedCandidates?.[0]?.id != null
                                ? 1
                                : 0) +
                              (props?.multiBid ? props.selectedCandidates?.length : 0) >
                            200
                          ) {
                            setGigAlert(true);
                            setTimeout(() => {
                              setGigAlert(false);
                            }, 4000);
                          } else {
                            setselectedGigDetails(item);
                          }
                        }}
                      >
                        <div
                          className={`jobcard-container ${
                            selectedGigDetails?._id === item?._id
                              ? 'ChooseGig-selected-card-pvt'
                              : null
                          } ${item.isDisabled ? 'jobcard-container-disabled' : null}`}
                        >
                          <JobCard
                            {...item}
                            key={item?.JobOrderId}
                            img={
                              item?.Regions?.Code !== null &&
                              item?.Cities?.CityName !== null
                                ? getImageByStateCode(
                                    item?.Regions?.Code,
                                    item?.Cities?.CityName,
                                    item?.CompanyName
                                  )
                                : ''
                            }
                            budgetType={item?.BudgetTypes?.BudgetTypeCode}
                            RegionCode={item?.Regions?.Code}
                            CityName={item?.Cities?.CityName}
                            id={item?.JobOrderId}
                            location={item.Location?.LocationWithCountry}
                            title={item?.Title}
                            facilityname={item?.FacilityName}
                            budget={item?.BudgetMin}
                            rate={item?.BudgetTypes?.BudgetTypeName}
                            cardFooter={false}
                            cardFooterChoose={true}
                            fromDashboard={true}
                            professionCode={props.professionCode?.Professions?.ProfessionCode}
                            rating={item?.facilityRating?.rating}
                            WorkplacePolicy={item?.WorkplacePolicy}
                            created={item?.Created}
                            matchedbids={item?.status?.[2]?.count}
                            placedbids={item?.status?.[0]?.count}
                            receivedbids={item?.status?.[1]?.count}
                            isPrivate={item?.isPrivate}
                          />
                        </div>
                      </Col>
                    );
                  }
                })
              ) : (
                <div className="emptyOtherSearch">
                  {flag ? (
                    <Empty style={{ weight: '100%' }} />
                  ) : (
                    <div className="employer-profile-body">
                      <div className="employer-profile-body-content" style={{ margin: '10px' }}>
                        <img className="nojobimage" src={props.noJobs} />
                        <div className="nojobtext">Create a gig to let candidates know you're hiring!</div>
                        <button className="postajob-btn" onClick={() => history.push('/postjob')}>
                          <span className="postjobbtn_plussign">+</span>
                          <span className="postjobbtn_text">Post a gig</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </Row>
          </InfiniteScroll>
        </div>
        <div className="ChooseGigsButton-btn">
          <ChooseGigsButton
            talentName={!props?.multiBid && props?.fromDetailPage ? getUserName() : null}
            MessageEditsection={props?.MessageEditsection}
            ConversationId={props?.selectedCandidates}
            path={location.pathname}
            nextHandler={nextHandler}
            backHandler={backHandler}
            selectedGigDetails={selectedGigDetails}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ChooseGigModal;
